import {GroupDropdown} from "../../../components/composites/UserGroupDropdown"

export default GroupDropdown;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/CreateUserModal/GroupDropdown.jsx